import React, { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { api } from "../utils/apiHelper";
import "../styles/SpecialPay.css";

const SpecialStripePay = ({ total, product, authUser, guestEmail, onPaymentSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
 
  const [name, setName] = useState("");
  const [processing, setProcessing] = useState(false);
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState("");


const handleSubmit = async (e) => {
  e.preventDefault();

  if (Number(total) > 0 && (!stripe || !elements)) return;

  const getPurchaserId = () => {
    // Logged-in user
    if (authUser?._id) {
      return authUser._id;
    }

    // Guest user
    let guestId = localStorage.getItem("guestUserId");

    if (!guestId) {
      guestId = `guest-${crypto.randomUUID()}`;
    }

    return guestId;
  };

  const purchaserId = getPurchaserId();

  const purchaserEmail =
    authUser?.email || guestEmail;

  setProcessing(true);
  setError("");

  try {

    if (Number(total) === 0) {
      const receipt = {
        orderId: crypto.randomUUID(),
        purchasedBy: purchaserId,
        email: purchaserEmail,
        timestamp: new Date().toISOString(),
        total: 0,
        products: [
          {
            projectId: product.productId,
            title: product.title,
            description: product.description,
            price: 0,
            purchaseRef: crypto.randomUUID(),
            file: product.file,
            image: product.image,
          },
        ],
      };

      const zipResponse = await api(
        "/generate-special-product-zip",
        "POST",
        {
          userId: purchaserId,
          email: purchaserEmail,
          receipt,
        }
      );

      if (!zipResponse?.success) {
        throw new Error(
          "Free download generation failed."
        );
      }

      setSucceeded(true);

      if (onPaymentSuccess) {
        onPaymentSuccess(
          "Your free download has been sent."
        );
      }

      return;
    }

    const paymentResponse = await api(
      "/create-special-payment-intent",
      "POST",
      {
        amount: Math.round(total * 100),
        userId: purchaserId,
        email: purchaserEmail,
        specialProduct: {
          productId: product.productId,
          title: product.title,
          description: product.description,
          price: total,
          file: product.file,
          image: product.image,
        },
      }
    );

    if (!paymentResponse?.clientSecret) {
      throw new Error(
        "Unable to initialize payment."
      );
    }

    const result = await stripe.confirmCardPayment(
      paymentResponse.clientSecret,
      {
        payment_method: {
          card: elements.getElement(CardElement),
          billing_details: {
            name,
            email: purchaserEmail,
          },
        },
      }
    );

    if (result.error) {
      throw new Error(result.error.message);
    }

    if (result.paymentIntent.status !== "succeeded") {
      throw new Error(
        "Payment was not completed."
      );
    }
  console.log(paymentResponse);

let zipResponse;

for (const receipt of paymentResponse.receipts) {
  zipResponse = await api(
    "/generate-special-product-zip",
    "POST",
    {
      userId: purchaserId,
      email: purchaserEmail,
      receipt,
    }
  );

  
  console.log("Here is the zip:", zipResponse);

  if (!zipResponse?.success) {
    throw new Error(
      "Payment succeeded, but ZIP generation failed."
    );
  }
}


  if (purchaserId) {
    await api("/clear-cart", "POST", {
      userId: purchaserId,
    });
  }

  setSucceeded(true);
  setName("");
  elements.getElement(CardElement).clear();

  if (onPaymentSuccess) {
    onPaymentSuccess(
      paymentResponse.message ||
        "Payment successful!"
    );
  }
} catch (err) {
  console.error(err);
  setError(err.message);
} finally {
  setProcessing(false);
}
  };

  return (
   <form
  onSubmit={handleSubmit}
  className="stripe-pay-form"
>
  {Number(total) > 0 && (
    <>
      <h3>Payment Details</h3>

      <input
        type="text"
        className="stripe-pay-form-input"
        placeholder="Name on card"
        value={name}
        onChange={(e) =>
          setName(e.target.value)
        }
        required
      />

      <CardElement className="CardElement" />
    </>
  )}

  <button
    className="stripe-pay-form-button"
    type="submit"
    disabled={
      processing ||
      succeeded ||
      (Number(total) > 0 && !stripe)
    }
  >
    {processing
      ? "Processing..."
      : Number(total) === 0
      ? "Get Free Download"
      : `Pay $${Number(total).toFixed(2)}`}
  </button>

  {error && (
    <div className="error-message">
      {error}
    </div>
  )}

  {succeeded && (
    <div className="success-message">
      ✅ {Number(total) === 0
        ? "Download sent!"
        : "Payment successful!"}
    </div>
  )}
</form>
  );
};

export default SpecialStripePay;